import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";
import styles from './VendorAddressManage.module.css';

function VendorAddressManage() {
    const location = useLocation();
    const inputs = useRef([]);
    const { t } = useTranslation();

    const [stores, setStores] = useState([]);
    const [selectedStore, setSelectedStore] = useState(null);
    const [info, setInfo] = useState();
    const [enroll_company, setEnroll_company] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    // 매장 목록 조회
    useEffect(() => {
        fetchStores()
    }, []);

    const fetchStores = async () => {
        setIsLoading(true);
        await requester.findAllStoresByVendorUserName((result) => {
            setStores(result.data);
            setIsLoading(false);
        });
    }

    // 매장 선택 핸들러
    const handleStoreSelect = (store) => {
        setSelectedStore(store);
        setInfo({
            id: store.id,
            storeName: store.storeName,
            storeCode: store.storeCode,
            address: store.address,
            latitudeByX: store.latitudeByX,
            longitudeByY: store.longitudeByY,
            zonecode: store.zonecode
        });
    };

    const addressKrModalClick = () => {
        NiceModal.show("addressKr", { onCallback: addressKrCallback });
    };

    const addressKrCallback = (dataFromModal) => {
        const kakao = window.kakao;
        const geocoder = new kakao.maps.services.Geocoder();

        geocoder.addressSearch(dataFromModal.address, function (result, status) {
            if (status === kakao.maps.services.Status.OK) {
                const { x, y } = result[0];

                setInfo((prevInfo) => ({
                    ...prevInfo,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                    latitudeByX: x,
                    longitudeByY: y,
                }));

                setEnroll_company((prevState) => ({
                    ...prevState,
                    address: dataFromModal.address,
                    zonecode: dataFromModal.zonecode,
                }));
            } else {
                console.error("주소 변환 실패:", status);
            }
        });
    };

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    };

    const update = () => {
        let data = {
            id: info.id,
            storeName: "",
            storeCode: "",
            address: "",
            latitudeByX: "",
            longitudeByY: ""
        };

        validateInputs(inputs.current).then((isValid) => {
            if (isValid) {
                data.storeName = inputs.current[0].getValue();
                data.address = inputs.current[1].getValue();
                data.storeCode = inputs.current[2].getValue();
                data.latitudeByX = info.latitudeByX;
                data.longitudeByY = info.longitudeByY;

                requester.updateStore(data, (result) => {
                    console.log(result.data);
                    toast.success(t("updateSuccess"), {
                        autoClose: 1000,
                        position: toast.POSITION.BOTTOM_CENTER
                    });

                    fetchStores()
                });
            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* 헤더 섹션 */}
                <div className={styles.headerSection}>
                    <h1 className={styles.title}>배송지 수정</h1>
                    <p className={styles.subtitle}>매장별 배송지 정보를 관리할 수 있습니다.</p>
                </div>

                {/* 매장 선택 섹션 */}
                <div className={styles.section}>
                    <div className={styles.sectionTitle}>매장 선택</div>
                    <div className={styles.storeGrid}>
                        {stores.map((store) => (
                            <button
                                key={store.id}
                                className={`${styles.storeButton} ${selectedStore?.id === store.id ? styles.selected : ''}`}
                                onClick={() => handleStoreSelect(store)}
                            >
                                {store.storeName}
                            </button>
                        ))}
                    </div>
                </div>

                {/* 매장 정보 폼 */}
                {selectedStore && (
                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>매장 정보</div>
                        <div className={styles.formGrid}>
                            <div className={styles.formGroup}>
                                <label className={styles.label}>매장명</label>
                                <input
                                    type="text"
                                    className={styles.input}
                                    value={info?.storeName || ''}
                                    ref={el => (inputs.current[0] = el)}
                                    placeholder="매장명"
                                    readOnly
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label className={styles.label}>주소</label>
                                <div className={styles.addressGroup}>
                                    <input
                                        type="text"
                                        className={styles.input}
                                        value={info && `${info?.address + (info.zonecode ? `(${info.zonecode})` : "")}` || ''}
                                        ref={el => (inputs.current[1] = el)}
                                        placeholder="주소"
                                    />
                                    <button
                                        className={styles.addressButton}
                                        onClick={addressKrModalClick}
                                    >
                                        주소찾기
                                    </button>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label className={styles.label}>좌표</label>
                                <div className={styles.coordinatesGroup}>
                                    <div className={styles.coordinate}>
                                        <span>위도: </span>
                                        <span className={styles.coordinateValue}>{info?.latitudeByX || '-'}</span>
                                    </div>
                                    <div className={styles.coordinate}>
                                        <span>경도: </span>
                                        <span className={styles.coordinateValue}>{info?.longitudeByY || '-'}</span>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.formGroup}>
                                <label className={styles.label}>상점 코드</label>
                                <input
                                    type="text"
                                    className={styles.input}
                                    value={info?.storeCode || ''}
                                    ref={el => (inputs.current[2] = el)}
                                    placeholder="상점코드"
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className={styles.actionButtons}>
                            <button
                                className={styles.submitButton}
                                onClick={update}
                            >
                                수정하기
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default VendorAddressManage;